import{a as i}from"./chunk-WIMGWYZL.js";function n(...t){return i(e,t)}var e=t=>`${t[0]?.toUpperCase()??""}${t.slice(1)}`;export{n as a};
